export namespace BeerProperties {
  export type SugarContentTypeEnum =
    | 'NORMAL'
    | 'CONTAINS_SUGAR'
    | 'CONTAINS_REDUCED_SUGAR'
    | 'SUGAR_FREE'
    | 'LIGHT';
  export const SugarContentTypeEnum = {
    Normal: 'NORMAL' as SugarContentTypeEnum,
    ContainsSugar: 'CONTAINS_SUGAR' as SugarContentTypeEnum,
    ContainsReducedSugar: 'CONTAINS_REDUCED_SUGAR' as SugarContentTypeEnum,
    SugarFree: 'SUGAR_FREE' as SugarContentTypeEnum,
    Light: 'LIGHT' as SugarContentTypeEnum,
  };
}
